import "./contact.css";
import Button1 from "../../../../components/buttons/button1/Button1";
import { swalPopUp } from "../../../../utils/swal";
import { useContext, useRef } from "react";
import { SpinnerContext } from "../../../../context/spinnerContext";
import { formValues } from "../../../../types/types";

function Contact() {
                 
    const {showSpinner} = useContext(SpinnerContext);
    const formRef = useRef <HTMLFormElement | null> (null);
            
    const validateForm = async () => {
                            
        const formData = new FormData(formRef.current as HTMLFormElement);
        const data = Object.fromEntries(formData) as formValues;
        const formValues = Object.values(data);
        
        if (formValues.every((input) => input.trim() !== "")) {
            sendForm();    
        } else {
            swalPopUp("Ops!", "Falta Ingresar Algún Dato", "warning");       
        }
    };  

    const sendForm = async () => {
    
        const formData = new FormData(formRef.current as HTMLFormElement);
        const data = Object.fromEntries(formData) as formValues;

        try {
            showSpinner(true);
            const respJSON = await fetch ("/sendmail.php", {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            });

            const respOBJ = await respJSON.json();
            showSpinner(false);
            if (respOBJ.msg.includes("Error")) {
                swalPopUp("Ops!", `${respOBJ.msg}, Intente otra vez`, "error");
            } else {
                const inputs: NodeListOf<HTMLInputElement> = document.querySelectorAll(".inputForm");
                inputs.forEach((input) => input.value = "");
                swalPopUp("Enviado!", "Mensaje enviado con éxito, gracias por contactarnos!", "success");
                const contactInputs = document.querySelectorAll(".contactInputs") as NodeListOf<HTMLInputElement>;
                contactInputs.forEach((input) => input.value = "");
            } 
            
        } catch (err: unknown) {
            showSpinner(false); 
            swalPopUp("Ops!", err instanceof Error ? `Error al enviar el mensaje: ${err.message}` : "Error al enviar el mensaje: problema desconocido", "error");
        }
    };
    

    return (
        <div className="contactCont flex" id="contacto">
            <div className="contactTextMainCont">
                <div className="contactTextTopCont flex">
                    <p className="contactTextTitle">Envíanos <br /> tu consulta</p>
                    <img src="/images/logo2.png" alt="Logo" className="contactLogoImg"/>
                </div>
                <div className="contactTextBottomCont flex">
                    <p className="contactTextSubTitle">
                        DÉJANOS TU CONSULTA Y EN BREVE <br />
                        NOS PONDREMOS EN CONTACTO CON VOS.
                    </p>
                </div>
            </div>
            <form className="contactFormCont flex column" ref={formRef}>
                <div className="contactInputsCont">
                    <img src="/images/icons/user.png" alt="User" className="contactInputImg"/>
                    <input type="text" className="contactInputs flex" placeholder="Nombre *" name="name"/>
                </div>
                <div className="contactInputsCont">
                    <img src="/images/icons/phone2.png" alt="Phone" className="contactInputImg"/>
                    <input type="text" className="contactInputs flex" placeholder="Teléfono *" name="phone"/>
                </div>
                <div className="contactInputsCont"> 
                    <img src="/images/icons/email3.png" alt="Email" className="contactInputImg"/>
                    <input type="text" className="contactInputs flex" placeholder="Email *" name="email"/>
                </div>
                <div className="contactInputsCont contactTextAreaCont">
                    <img src="/images/icons/message.png" alt="Message" className="contactInputImg contactInputImgTextArea"/>
                    <textarea className="contactInputs contactTextArea flex" placeholder="Mensaje" name="message"/>
                </div>
                <Button1 text="Enviar" color="#284b63" height={3} width={10} onClickFunction={validateForm}/>
            </form>
        </div>
    );
}

export default Contact;